module.exports = __webpack_public_path__ + "img/vertebra2.b1d23aee.svg";